import { render, staticRenderFns } from "./event-list.vue?vue&type=template&id=14a23131"
import script from "./event-list.vue?vue&type=script&lang=js"
export * from "./event-list.vue?vue&type=script&lang=js"
import style0 from "./event-list.vue?vue&type=style&index=0&id=14a23131&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports